<template>
  <div class="flex flex-col">
    <h2>Órdenes de Compra</h2>

    <div class="flex flex-col lg:flex-row gap-4 lg:gap-6 mt-6 items-start">
      <status-side-nav :options="statusNavOptions" />

      <div class="flex-1 min-w-0 w-full">
    <div class="flex flex-col">
      <div class="card mt-6">
        <table class="table-auto text-sm mt-2 bg-white">
          <thead class="text-left">
            <tr class="bg-gray-100">
              <th class="p-2 rounded-l-lg">ID</th>
              <th class="p-2">Fecha de creación</th>
              <th class="p-2 rounded-r-lg">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="order in productOrders" :key="order.id" class="table-row">
              <td class="table-cell">
                {{ order.id }}
              </td>
              <td class="table-cell">
                {{ formatDatetime(order.created_at) }}
              </td>
              <td class="table-cell">
                <div class="flex space-x-1">
                  <router-link
                    :to="{
                      name: 'productOrdersDetail',
                      params: { id: order.id },
                    }"
                    class="secondary-button"
                    >Detalle</router-link
                  >
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="loading" class="flex w-full h-full items-center">
          <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
        </div>
      </div>
    </div>

    <pagination
      :current-page="currentPage"
      :total-pages="totalPages"
      @page-change="onPageChange"
    />
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import Pagination from "@/components/ui/Pagination.vue";
import StatusSideNav from "@/components/ui/StatusSideNav";
import { formatDatetime } from "@/utils/dateFormatter";
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "Product Orders",

  components: {
    Pagination,
    StatusSideNav,
  },

  computed: {
    statusNavOptions() {
      return [
        { status: "pending", label: "Pendientes", icon: "\ud83d\udd50", activeClass: "text-tertiary-500" },
        { status: "completed", label: "Completadas", icon: "\u2705", activeClass: "text-success-500" },
      ].map((option) => ({
        label: option.label,
        icon: option.icon,
        to: { name: "productOrdersIndex", query: { status: option.status } },
        active: this.$route.query.status === option.status,
        activeClass: option.activeClass,
      }));
    },
  },

  data() {
    return {
      productOrders: null,
      loading: false,
      status: null,
      searchText: "",
      currentPage: 1,
      totalPages: 0,
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "productOrders");

    this.status = this.$route.query.status;
    if (!this.status) {
      this.$router.push({
        name: "productOrdersIndex",
        query: { status: "pending" },
      });
    }

    // this.loadProductOrders();
  },

  methods: {
    formatDatetime,

    integerToCurrency,

    async loadProductOrders() {
      this.loading = true;

      try {
        const response = await api.productOrders.getByBranch(
          this.$route.params.branchId,
          [
            { name: "status", value: this.status },
            {
              name: "page",
              value: this.currentPage,
            },
          ]
        );
        this.productOrders = response.data;
        this.currentPage = response.current_page;
        this.totalPages = response.last_page;
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    search() {
      this.currentPage = 1;
      this.loadProductOrders();
    },

    onPageChange(page) {
      this.currentPage = page;
      this.loadProductOrders();
    },
  },

  watch: {
    "$route.query.status": {
      immediate: true,
      handler(newStatus) {
        this.status = newStatus || "pending";
        this.loadProductOrders();
      },
    },
  },
};
</script>